import * as React from "react";
import { valueToStoredString, storedStringToValue, stringifyKey, } from "./utils";
const storeMap = {};
const getStorageStore_getSnapshot = (storageType, keyString, initialValue) => {
    const raw = storageType === "localStorage"
        ? localStorage.getItem(keyString)
        : sessionStorage.getItem(keyString);
    return raw !== null ? raw : valueToStoredString(initialValue);
};
function getStorageStore(storageType, key, initialValue) {
    const keyString = stringifyKey(key);
    if (!storeMap[keyString]) {
        const listeners = new Set();
        const getSnapshot = () => getStorageStore_getSnapshot(storageType, keyString, initialValue);
        const setValue = (value) => {
            const stored = valueToStoredString(value);
            if (stored !== undefined) {
                if (storageType === "localStorage") {
                    localStorage.setItem(keyString, stored);
                }
                else {
                    sessionStorage.setItem(keyString, stored);
                }
            }
            else {
                if (storageType === "localStorage") {
                    localStorage.removeItem(keyString);
                }
                else {
                    sessionStorage.removeItem(keyString);
                }
            }
            listeners.forEach((l) => l());
            window.dispatchEvent(new StorageEvent("storage", {
                key: keyString,
                newValue: stored,
                storageArea: storageType === "localStorage" ? localStorage : sessionStorage,
            }));
        };
        const subscribe = (listener) => {
            listeners.add(listener);
            const onStorage = (e) => {
                if (e.key === keyString) {
                    listener();
                }
            };
            window.addEventListener("storage", onStorage);
            return () => {
                listeners.delete(listener);
                window.removeEventListener("storage", onStorage);
            };
        };
        const stored = { subscribe, getSnapshot, setValue };
        storeMap[keyString] = stored;
        return stored;
    }
    return storeMap[keyString];
}
export function useState(storageType, key, initialValue) {
    const { subscribe, getSnapshot, setValue } = getStorageStore(storageType, key, initialValue);
    // Si undefined: pas de valeur enregistrée dans le storage
    const raw = React.useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
    const value = React.useMemo(() => {
        try {
            return raw !== undefined ? storedStringToValue(raw) : initialValue;
        }
        catch {
            return initialValue;
        }
    }, [raw, initialValue]);
    const setVal = React.useCallback((updater) => {
        const raw = getSnapshot();
        const current = raw === undefined ? initialValue : storedStringToValue(raw);
        const newVal = typeof updater === "function"
            ? updater(current)
            : updater;
        setValue(newVal);
    }, [getSnapshot, initialValue]);
    return [value, setVal];
}
